// extracted by mini-css-extract-plugin
export default {"container":"TeamRecord_container__digFK"};